import Vue from 'vue'
import { DaMessage } from '../components/message-box'

Vue.use(DaMessage)
